<template>
  <div>
    <h2 class="step-name">Email Notifications</h2>
    <h3>The following email notifications will be sent for follow up actions</h3>

    <div class="step-section">
      <table style="width: 100%" class="table text-left">
        <tbody>
          <tr v-for="notification in getFieldValue('notifications')" :key="notification.slug"
            :class="notification.marked || notification.auto_generated ? 'success' : 'text-muted'">
            <td>{{ notification.name }}</td>

            <td>
              <div class="form-group" v-if="notification.comments.length > 0">
                <template v-if="notification.slug == 'gfc-markers-digest'">
                  <template v-if="notification.marked || notification.auto_generated">
                    <div class="form-group" v-for="comment in notification.comments" :key="comment.field_name">
                      <template v-if="
                        comment.field_name.endsWith('booking_notes') &&
                        showCommentsForProgram(getProgramFromFieldName(comment.field_name))
                      ">
                        {{ markersDigestCommentTitle(comment.field_name) }}
                        <comments :field-name="comment.field_name" :model-name="comment.step_name_display"
                          @on-change="syncContactDetails">
                        </comments>
                      </template>
                    </div>

                    <hr />
                    <br />
                  </template>
                </template>
                <template v-else><span class="form-group" v-if="notification.marked || notification.auto_generated">
                    <comments :field-name="notification.comments[0].field_name"
                      :model-name="notification.comments[0].step_name_display" @on-change="syncContactDetails">
                    </comments>
                  </span></template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'EmailNotifications',
  mixins: [baseComponent],
  methods: {
    showCommentsForProgram(program) {
      if (!program) return false
      return (
        this.getFieldComment(`${program.slug.replaceAll('-', '_')}_booking_notes`, 'Programmes').current ||
        this.getFieldValue(this.prefixedField('active_before', program.id, 'cm'), 'Programmes') !=
        this.getFieldValue(this.prefixedField('active_after', program.id, 'cm'), 'Programmes')
      )
    },
    getProgramFromFieldName(fieldName) {
      let programSlug = fieldName.replace('_booking_notes', '').replaceAll('_', '-')
      return this.getProgram(programSlug)
    },
    markersDigestCommentTitle: function (fieldName) {
      return `${this.getProgramFromFieldName(fieldName).name} Booking Notes`
    },
    syncContactDetails: function (payload) {
      if (payload.fieldName == 'delivery_notes' && payload.modelName == 'ContactDetails') {
        this.setFieldValue({
          modelName: 'ContactDetails',
          fieldName: 'on_farm_delivery_details_text',
          value: payload.value,
        })
      }
    },
  },
  computed: {
    ...mapGetters('currentConsult', ['getFieldValue', 'getProgram']),
  },
}
</script>
